//export let b = 12;

export let constantes =
{
    itk: {
        culture_variete: [
            "ABBY", "ADORA", "AGATA", "AGRIA", "AIDA", "ALASKA", "ALCMARIA", "ALEXIA", "ALIZEE", "ALLIANS", "ALOWA", "ALTESSE", "AMANDINE", "AMANY", "AMBRINE", "AMELIE", "AMIGO", "AMINCA", "AMYLA", "ANAÏS", "ANGELIQUE", "ANIEL", "ANNABELLE", "ANOE", "APOLLO", "ARTEMIS", "ASTERIX", "ATLAS", "ATOLL", "AUREA", "AZILIS", "B.F. 15", "BEA", "BELLANITA", "BELLE DE FONTENAY", "BERNADETTE", "BINTJE", "BLONDINE", "BRITNEY", "CAESAR", "CAPUCINE", "CARLITA", "CARMINELLE", "CARRERA", "CECILE", "CELANDINE", "CELTIANE", "CEPHORA", "CERISA", "CHARLENE", "CHARLOTTE", "CHARMEUSE", "CHERIE", "CHEYENNE", "CHIPIE", "CICERO", "CIRIELLE", "CLAIRETTE", "CLAUSTAR", "CLEMENCE", "CN 99.113.1", "COQUINE", "COROLLE", "CRISPS4ALL", "CROKY", "DAIFLA", "DAISY", "DALI", "DALIDA", "DARTIEST", "DELICE", "DELILA", "DESIREE", "DITTA", "DOLLY", "DONALD", "DOUNIA", "ECRIN", "EDEN", "EL BEIDA", "ELODIE", "EMERAUDE", "EPONA", "ERIKA", "ERIS", "EUROPA", "EXQUISA", "FELSINA", "FLORICE", "FONTANE", "FRANCELINE", "FRIVOL", "GAIANE", "GALANTE", "GOURMANDINE", "GOURMET", "GRENADINE", "GWENNE", "HANSA", "HERMINE", "HINGA", "ILEDHER", "IMPALA", "INNOVATOR", "INSTITUT DE BEAUVAIS", "ISABEL", "JAERLA", "JAZZY", "JOSE", "JULIETTE", "JUWEL", "KAPTAH VANDEL", "KARDAL", "KELLY", "KENNEBEC", "KERPONDY", "KONDOR", "KRONE", "KURODA", "LADY CHRISTL", "LADY CLAIRE", "LADY FELICIA", "LADY OLYMPIA", "LADY ROSETTA", "LANORMA", "LAURA", "LAURETTE", "LD17", "LEONTINE", "LINZER DELIKATESS", "LISETA", "LOUISANA", "LOVALIE", "LUCIOLE", "MAESTRO", "MAGNUM", "MAIWEN", "MAKHAÏ", "MALDIVE", "MALICE", "MANDOLA", "MANON", "MARABEL", "MARGOD", "MARIA SARAH", "MARILYN", "MARINE", "MARKIES", "MAVERICK", "MELODY", "MILVA", "MISS ANDES", "MISS MIGNONNE", "MONALISA", "MONDIAL", "NAIMA", "NAZCA", "NICOLA", "NOHA", "NOISETTE", "OCEANIA", "OCLAIRE", "ONDINE", "OPERLE", "OSTARA", "O’SIRENE", "PAMELA", "PAMINA", "PASSION", "PENELOPE", "PLATINA", "POMDOR", "POMPADOUR", "PONTO", "PREMIERE", "PRIAM", "PRODUCENT", "RACKAM", "RAINBOW", "RAMOS", "RATTE", "RED PONTIAC", "REINE", "RESY", "RODEO", "ROSA", "ROSABELLE", "ROSANNA", "ROSEVAL", "RUBIS", "RUMBA", "RUSSET BURBANK", "SAFRANE", "SAHEL", "SAMBA", "SANTANA", "SATIS", "SATURNA", "SELENA", "SERVANE", "SHEPODY", "SIEGLINDE", "SIRCO", "SIRTEMA", "SISSI", "SOLEIA", "SOLEN", "SPARTAAN", "SPUNTA", "STARLETTE", "STELLA", "STEMSTER", "STRONGA", "SURYA", "SYNERGY", "TALENTINE", "TENDRESSE", "TENTATION", "TOUAREG", "TRESOR", "TRIOMPHE", "TURBO", "UNIVERSA", "URGENTA", "VALERY", "VICTORIA", "VIOLA", "VIVALDI", "VOYAGER", "ZEN"
        ],
        hauteur_butte: {
            value: 20, // valeur constante
        }
    },
    sols: {
        horizon: {
            validation: function(value) {
                return ([1, 2, 3].indexOf(value) !== -1);
            }
        },
        triangle: {
            defaultValue: '\\"AISNE\\"',
            values: [
                { text: "AISNE", value: '\\"AISNE\\"' },
                { text: "USDA", value: "USDA"  },
                { text: "HYPRES", value: "HYPRES"  },
            ]
        },
        texture: {
            defaultValue: "S",
            label: "Texture",
            values: [
                {
                    value: null,
                    text: "",
                },
                {
                  value: "ALO",
                  text: "Argile lourde"
                },
                {
                  value: "A",
                  text: "Argile"
                },
                {
                  value: "AL",
                  text: "Argile limoneuse"
                },
                {
                  value: "AS",
                  text: "Argile sableuse"
                },
                {
                  value: "LA",
                  text: "Limon argileux"
                },
                {
                  value: "LAS",
                  text: "Limon argilo-sableux"
                },
                {
                  value: "LSA",
                  text: "Limon sablo-argileux"
                },
                {
                  value: "SA",
                  text: "Sable argileux"
                },
                {
                  value: "LM",
                  text: "Limon moyen"
                },
                {
                  value: "LMS",
                  text: "Limon moyen sableux"
                },
                {
                  value: "LS",
                  text: "Limon sableux"
                },
                {
                  value: "SL",
                  text: "Sable limoneux"
                },
                {
                  value: "S",
                  text: "Sable"
                },
                {
                  value: "LL",
                  text: "Limon léger"
                },
                {
                  value: "LLS",
                  text: "Limon léger sableux"
                }
            ],
        },
        argile: {
            label: "Argile",
            unite: '%',
        },
        limon: {
            label: "Limon",
            unite: '%',
        },
        sable: {
            label: "Sable",
            unite: '%',
        },
    },
    irrigation: {
        seuil_relatif: {
            label: "Seuil relatif",
            unite: "-",
        },
        dose_min:  {
            label: "Dose min",
            unite: "",
        },
        dose_max:  {
            label: "Dose max",
            unite: "",
        },
        retour_min:  {
            label: "Retour min",
            unite: "",
        },
        retour_max:  {
            label: "Retour max",
            unite: "",
        },
        mise_en_reserve: {
            label: "Mise en réserve",
            unite: "",
        },
        volume_irrigation_total: {
            label: "Volume d'irrigation total",
            value: 10000,
            unite: "mm",
        },
        efficience_irrigation: {
            label: "Efficience de l'irrigation",
            value: 100,
            unite: "%",
        },
        phase: [
            {
                stade_debut: 'plantation',
                stade_fin: 'plant_germe',
                seuil_relatif_defaut: 0,
                dose_min_defaut: 0,
                dose_max_defaut: 35,
                retour_min_defaut: 0,
                retour_max_defaut: 10,
                mise_en_reserve_defaut: 0,
            },
            {
                stade_debut: 'plant_germe',
                stade_fin: 'levee',
                seuil_relatif_defaut: 0,
                dose_min_defaut: 0,
                dose_max_defaut: 35,
                retour_min_defaut: 0,
                retour_max_defaut: 10,
                mise_en_reserve_defaut: 0,
            },
            {
                stade_debut: 'levee',
                stade_fin: 'tubercules_inities',
                seuil_relatif_defaut: 0,
                dose_min_defaut: 0,
                dose_max_defaut: 35,
                retour_min_defaut: 0,
                retour_max_defaut: 10,
                mise_en_reserve_defaut: 0,
            },
            {
                stade_debut: 'tubercules_inities',
                stade_fin: 'defanage',
                seuil_relatif_defaut: 0,
                dose_min_defaut: 0,
                dose_max_defaut: 35,
                retour_min_defaut: 0,
                retour_max_defaut: 10,
                mise_en_reserve_defaut: 0,
            },
            {
                stade_debut: 'defanage',
                stade_fin: 'recolte',
                seuil_relatif_defaut: 0,
                dose_min_defaut: 0,
                dose_max_defaut: 35,
                retour_min_defaut: 0,
                retour_max_defaut: 10,
                mise_en_reserve_defaut: 0,
            },
        ],
    },
    forcage: {
        variable: {
            values: [
                {
                    text: "Nombre de tiges par plante",
                    value: "tiges_par_plante",
                },
                {
                    text: "Nombre de tubercules (par m², calibre >= 15mm)",
                    value: "tubercules_sup15_nombre",
                },
                {
                    text: "Nombre de tubercules (par plante, calibre >= 15mm)",
                    value: "tubercules_sup15_nombre_par_plante",
                },
                {
                    text: "Rendement total des tubercules (t.ha-1)",
                    value: "tubercules_matiere_fraiche",
                },
            ],
        }
    },
    scenarios_meteo: {
        agri4cast: { // Années allant jusque 2022 (cf. partie "length" dans l'instruction ci-dessous)
            annees: Array.from({length: 2022 - 1979 + 1}, (_, x ) => 1979 + x).reverse()
        },
    },
    fichier_output: {
        fichier_output: {
            values: [
                {
                    text: "fichier_meteo",
                    value: "fichier_meteo",
                },
                {
                    text: "log_culture",
                    value: "log_culture",
                },
                {
                    text: "log_plante",
                    value: "log_plante",
                },
                {
                    text: "log_sol",
                    value: "log_sol",
                },
                {
                    text: "log_calibres",
                    value: "log_calibres",
                },
                {
                    text: "log_temperature_sol",
                    value: "log_temperature_sol",
                },
                {
                    text: "itk",
                    value: "itk",
                },
                {
                    text: "phases",
                    value: "phases",
                },
                {
                    text: "parametres_sim",
                    value: "parametres_sim",
                },
                {
                    text: "etat_initial",
                    value: "etat_initial",
                },
                {
                    text: "forcage",
                    value: "forcage",
                },
            ],
        }
    },
    villes: {
        defaultValue: '80200||',
        values: [
            {
                cp: "80170",
                ville:	"CHILLY",
            },
            {
                cp: "80190",
                ville:	"BIARRE",
            },
            {
                cp: "80190",
                ville:	"FALVY",
            },
            {
                cp: "80190",
                ville:	"CRESSY OMENCOURT",
            },
            {
                cp: "80190",
                ville:	"NESLE",
            },
            {
                cp: "80200",
                ville:	"",
            },
        ],
    },
    variables_interet_principale: {
        values: [
            {
                "value": "tubercules_matiere_fraiche",
                "text": "Rendement total des tubercules (t.ha-1)",
            },
            {
                "value": "tubercules_matiere_seche", 
                "text": "Rendement sec des tubercules (t.ha-1)",
            }, 
            {
                "value": "tubercules_sup15_nombre",
                "text": "Nombre de tubercules (par m², calibre >=15mm)",
            }, 
            {
                "value": "tubercules_sup15_nombre_par_plante",
                "text": "Nombre de tubercules (par plante, calibre >= 15mm)",
            },            
            {
                "value": "teneur_ms_tubercules",
                "text": "Teneur en matière sèche des tubercules (%)", 
            }, 
            {
                "value": "deficit_hydrique_plante",
                "text": "Déficit hydrique de la plante (mm)",
            },
        ]
    },

    variables_interet_calculees: {
        values: [
            {
                "value": "poids", 
            }, 
            {
                "value": "fraction", 
            },
        ]
    },
    variables_interet_supplementaire: {
        values: [
            {                    
                value: 'deficit_eau_sol_total',
                text: 'Déficit en eau du sol (mm)',
            },
            {                    
                value: 'drainage',
                text: 'Drainage (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'drainage_cumul',
                text: 'Drainage cumulé (mm)',
            },
            {                    
                value: 'eau_surface',
                text: 'Eau de surface (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'etat_reserve_racines',
                text: 'État hydrique compartiment racinaire (mm)',
            },
            {                    
                value: 'evaporation_sol',
                text: 'Évaporation du sol (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'evaporation_sol_cumul',
                text: 'Évaporation du sol cumulée (mm)',
            },
            {
                value: 'irrigation_cumul',
                text: 'Irrigation cumulée (mm)',
            },
            {                    
                value: 'irrigation_jour',
                text: 'Dose journalière d\'irrigation (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'irrigation_jour_efficiente',
                text: 'Dose journalière d\'irrigation efficiente (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            }, 
            {
                "value": "LAI",
                "text": "LAI",
                fct1resultat1: false,
                fct2resultat1: false,
            }, 
            {
                "value": "matiere_seche_jour", 
                "text": "Matière sèche totale jour (t.ha-1)",
                fct1resultat1: false,
                fct2resultat1: false,
            }, 
            {
                "value": "matiere_seche_cumul",
                "text": "Matière sèche totale cumulée (t.ha-1)",
            },
            {                    
                value: 'rayonnement_intercepte_cumul',
                text: 'Rayonnement intercepté cumulé (MJ)',
            },
            {                    
                value: 'rayonnement_intercepte_jour',
                text: 'Rayonnement intercepté (MJ)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'reserve_utile_racines',
                text: 'Réserve utile compartiment racinaire (mm)',
            },
            {                    
                value: 'surface_foliaire_plante',
                text: 'Surface foliaire plante (cm²)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'transpiration',
                text: 'Transpiration réelle (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'transpiration_cumul',
                text: 'Transpiration cumulée (mm)',
            },
            {                    
                value: 'transpiration_demande',
                text: 'Transpiration demande (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
            {                    
                value: 'transpiration_offre',
                text: 'Transpiration offre (mm)',
                fct1resultat1: false,
                fct2resultat1: false,
            },
        ],
    },
    fct: {
        
        /**
         * // ALGO <X>j consécutifs avec plus de <Y>°C suivi d'une pluie de plus de <Z>mm. 
         * @param {*} donneesMeteo 
         */
        risqueRepoussePhysiologique: function(donneesMeteo) {
            const X__J_CONSECUTIFS = 2;
            const Y__TEMP_SUP_Y_DEG = 4;
            const Z__PLUIE_SUP_Z_MM = 1;
            let tabJConsecutifsTempSupAYDeg = ArrayComplement.cumulSiConditionOkChaqueElementTableau(donneesMeteo, ((elt) => elt["T_air_moy"] > Y__TEMP_SUP_Y_DEG));
            let tabObjConsecutifsTempSupAYDeg = [];
            /* structure contenant la colonne "nb_j_consecutif_temp_supA_Ydegres" */
            let donneesMeteoNew = [];


            tabJConsecutifsTempSupAYDeg.forEach(n => tabObjConsecutifsTempSupAYDeg.push({nb_j_consecutif_temp_supA_Ydegres: n}));
                     
            for(let i in donneesMeteo) {
                donneesMeteoNew.push(Object.assign({}, donneesMeteo[i], tabObjConsecutifsTempSupAYDeg[i]));
            }

            let tab_XJConsecutifsSupAYDeg_suivi_PluieSupAXMm = ArrayComplement.testsChaqueElementTableau(donneesMeteoNew, ((elt, eltPrec) => undefined == eltPrec ? false : eltPrec["nb_j_consecutif_temp_supA_Ydegres"] > X__J_CONSECUTIFS && elt["pluie"] > Z__PLUIE_SUP_Z_MM));
            let estRisqueRepoussePhysiologique = (-1 == tab_XJConsecutifsSupAYDeg_suivi_PluieSupAXMm.findIndex) ? false : true;
            
            return estRisqueRepoussePhysiologique;
        }
    }
};


let ArrayComplement = {
    /**
      test chaque element tableau (param element + element precedent)
      elemTableauTestCondition
      
      @param {*[]} tab tableau pour lequel chaque élément seront testés
      @param {function(Object, Object):*} fctCritere fonction utilisée pour effectuer les tests
      @return {*[]} un tableau contenant pour chaque élément, le résultat du test
    */
    testsChaqueElementTableau: function(tab, fctCritere) {
      let retour = [];
  
      tab.forEach((elt, index) => {
        retour.push(fctCritere(elt, tab[index-1]));
      });
  
      return retour;
    },
  
   /**
    * teste chaque element avec notion de cumul
    * @param {*} tab 
    * @param {*} fctCritere 
    */
    cumulSiConditionOkChaqueElementTableau: function(tab, fctCritere) {
      let retour = [];
      let jCumulPrec = 0;
  
      tab.forEach(elt => {
        if(fctCritere(elt)) {
          retour.push(jCumulPrec + 1);
          jCumulPrec++;
        }
        else {
          retour.push(0);
          jCumulPrec = 0;
        }
      });
  
      return retour;
    }
  };


export const TabDeTab = {
    filter: function(tabDeTab, fctFiltre) {
        let tabDeTabNew = [];
        
        tabDeTab.forEach(jeuDonnees => {
            tabDeTabNew.push(jeuDonnees.filter(fctFiltre));
        });
        
        return tabDeTabNew;
    }
};



export function generateUuid() {
    return Math.floor(Math.random()*10000);
}

export function exportCsv(dataArray, pOptions) {
    const defaultOptions = {
        filename: 'export.csv'
    };
    const options = { ...defaultOptions, ...pOptions};


    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += dataArray
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

    const data = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", options.filename);
    link.click();
  }




export const helperCalibre = Object.freeze({
    fctCalibreTransfoNomVariableEnLabel: function(nomVarCalibre) {
        return "Rendement calibre " + nomVarCalibre.split('_').filter((eltI, indI) => -1 !== [1, 3].indexOf(indI)).join(" à ") + "mm (t/ha)";  
    }
});